/* ══════════════════════════════════════════════════════════════════════════
   AM26 — meniul lateral: acordeon real între categorii + armarea tranziţiei
   ══════════════════════════════════════════════════════════════════════════
   Tudor, 2026-08-05: „daca se deschide un submeniu din produse cand deja unu
   era deschis, cel anterior se inchide. eg daca casti era deschis si eu apas
   si pe boxe, casti se inchide".

   DE CE NU MERGE DEJA. Tema ARE acordeon — `custom-async.js:738-740`, în
   `navHandler`:

       Array.from(parentList.children).forEach(function (el) {
         el.classList.remove('toggle');
       });

   …unde `parentList = el.closest('ul')`. Nu se declanşează niciodată la nivelul
   categoriilor fiindcă mega-meniul le pune pe FIECARE în propria coloană:
   măsurat pe PRODUSE, 8 categorii în 8 wrappere `<li><ul>` separate, deci
   `parentList.children` are exact un copil — chiar elementul apăsat. Bucla
   rulează şi nu are ce închide.

   Aici închidem fraţii adevăraţi: toate `li.main-categ.toggle` din aceeaşi
   ramură de nivel 1, indiferent în ce coloană stau.

   FAZA DE CAPTURE, ca la comutatorul de grilă din am-collection-premium.js:
   handlerul temei e delegat pe `#nav` în faza de bubble (`custom-async.js:758`),
   deci al nostru trebuie să ruleze înaintea lui — altfel am închide fraţii DUPĂ
   ce tema a deschis noul, iar la a doua apăsare pe acelaşi element starea ar
   fi deja inconsistentă. Nu oprim propagarea: tema trebuie să-şi facă treaba
   normal pe elementul apăsat.

   Curăţăm şi `mtoggle`, pe care bucla temei îl lasă în urmă (scoate doar
   `toggle`). Reziduul nu e inofensiv — alimentează
   `am-nav-drawer.css:190` şi regulile de `display` care ţin de `li.mtoggle`.
   ══════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var CATEGORY = 'li.main-categ';

  function branchOf(li) {
    // ramura de nivel 1 (PRODUSE, PROMOŢII…) care conţine categoria apăsată
    var nav = li.closest('#nav');
    if (!nav) return null;
    var node = li;
    while (node && node.parentElement && node.parentElement.parentElement !== nav) {
      node = node.parentElement;
    }
    return node && node.parentElement === nav.querySelector(':scope > ul') ? node : nav;
  }

  document.addEventListener('click', function (event) {
    if (!event.target.closest) return;
    var toggle = event.target.closest('a.toggle');
    if (!toggle) return;

    var nav = toggle.closest('#nav');
    if (!nav) return;

    /* Armează tranziţia abia la prima interacţiune reală. Fără asta, prima
       randare a panoului porneşte din starea deschisă şi o animează spre
       închis — exact capcana prinsă la panoul de bullet-uri din cardul de
       produs (ATP-37, 2026-08-05). CSS-ul declară tranziţia doar sub
       `#nav[data-am-anim]`. */
    nav.setAttribute('data-am-anim', '');

    var me = toggle.closest(CATEGORY);
    if (!me) return;                          // nivel 1 sau „Înapoi" — tema se descurcă
    if (me.classList.contains('toggle')) return;  // se închide singur; nu atingem fraţii

    var branch = branchOf(me);
    if (!branch) return;

    branch.querySelectorAll(CATEGORY + '.toggle, ' + CATEGORY + '.mtoggle').forEach(function (other) {
      if (other === me) return;
      other.classList.remove('toggle', 'mtoggle');
      var otherToggle = other.querySelector(':scope > a.toggle');
      if (otherToggle) otherToggle.setAttribute('aria-expanded', 'false');
    });
  }, true);
})();

/* ══════════════════════════════════════════════════════════════════════════
   Accordion in-place — AM26 2026-08-11
   ══════════════════════════════════════════════════════════════════════════
   IIFE separat, deliberat: markup-ul .am-acc-* (header-menu.liquid, ramura
   `layout == 'am-accordion'`) e nou și nu se intersectează cu `a.toggle` de
   mai sus (acela e <a>, ăsta e <button class="am-acc-toggle">), deci n-are
   sens să împart state cu handlerul de sus — ar cupla două markup-uri care
   n-au nimic în comun doar ca să economisim câteva linii.

   REGULA: un singur `.am-acc-open` pe fiecare NIVEL, în cadrul PĂRINTELUI lui
   direct — nu global pe tot #nav. Altfel, deschizând un nivel-2 în interiorul
   lui „Luxury Hi-Fi" ar închide un nivel-2 deschis în interiorul lui
   „TV & Proiectoare", ceea ce n-are legătură cu ce a apăsat userul.

   TRANZIŢIA SMOOTH pe max-height cere o valoare NUMERICĂ, nu `auto` — CSS-ul
   nu poate anima spre `auto`. De aici scrollHeight pus inline la deschidere.
   La închidere setăm mai întâi max-height la valoarea curentă (nu 0 direct),
   ca tranziţia să aibă de la ce să pornească — altfel un panou care tocmai a
   fost deschis (max-height încă la valoarea lui scrollHeight) ar sări direct
   la 0 fără animaţie, pentru că following-frame-ul nu vede o schimbare de
   la-ceva-spre-altceva, ci de la fix-aceeaşi-valoare (browserul poate coalesce
   cele două seturi de style în același frame). */
(function () {
  'use strict';

  function panelOf(li) {
    return li.querySelector(':scope > .am-acc-panel');
  }

  // getAnimations() confirmat live: fără cancel(), o tranziţie întreruptă la
  // mijloc (close() apelat din nou peste una încă „running") rămâne blocată
  // pe valoarea ei curentă — computed max-height nu mai răspunde la NICIUN
  // scris ulterior, nici cu !important, până tranziţia veche nu e anulată
  // explicit. cancel() e sincron şi imediat, deci sigur de apelat înainte
  // de a scrie o valoare nouă.
  function cancelTransition(panel) {
    panel.getAnimations().forEach(function (a) { a.cancel(); });
  }

  // Înălţimea de care are nevoie un panou = lista lui + tot ce e desfăşurat
  // ÎN INTERIORUL ei, calculat recursiv.
  //
  // DE CE NU `scrollHeight`. Un panou-copil deschis are `overflow: hidden` +
  // max-height în px, deci e propriul container de clipping: conţinutul lui
  // NU se propagă în scrollHeight-ul strămoşilor. Măsurat pe cazul raportat
  // de Tudor (TV & Proiectoare > Televizoare): copilul avea max-height 262px
  // aplicat, iar părintele raporta în continuare scrollHeight 266px — adică
  // doar cele 6 rânduri de nivel 2, ca şi cum copilul ar fi închis. Nu era o
  // problemă de moment al măsurării (am re-măsurat manual după ce copilul
  // avea deja max-height — aceeaşi valoare): scrollHeight pur şi simplu nu
  // poate vedea prin descendenţi clipuiţi. De-aici suma explicită.
  //
  // Fix-ul precedent (re-scriere cu scrollHeight pe strămoşi) rezolva doar
  // cazul „copilul e ultimul din listă" din întâmplare; aici siblingii de sub
  // el dispăreau, fiindcă bugetul de înălţime nu-i mai cuprindea.
  function neededHeight(panel) {
    var total = 0;
    Array.prototype.forEach.call(panel.children, function (child) {
      total += child.getBoundingClientRect().height;
    });
    panel.querySelectorAll(':scope > * > .am-acc-open').forEach(function (openLi) {
      var inner = openLi.querySelector(':scope > .am-acc-panel');
      if (inner) total += neededHeight(inner);
    });
    return total;
  }

  // Se aplică la fel la închidere (altfel părintele rămâne prea înalt şi lasă
  // un gol), de-aici un singur helper pentru ambele sensuri. Merge în sus
  // până la #nav, deci rămâne corect dacă apare vreodată un nivel 3 cu toggle.
  function resyncAncestors(li) {
    var panel = li.parentElement ? li.parentElement.closest('.am-acc-panel') : null;
    while (panel) {
      var owner = panel.parentElement;
      if (!owner || !owner.classList.contains('am-acc-open')) break;
      cancelTransition(panel);
      panel.style.maxHeight = neededHeight(panel) + 'px';
      panel = owner.parentElement ? owner.parentElement.closest('.am-acc-panel') : null;
    }
  }

  function open(li) {
    var panel = panelOf(li);
    if (!panel) return;
    cancelTransition(panel);
    li.classList.add('am-acc-open');
    var toggle = li.querySelector(':scope > .am-acc-row > .am-acc-toggle');
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
    // neededHeight, nu scrollHeight: dacă acest nod se redeschide având deja
    // un nivel-2 desfăşurat înăuntru, scrollHeight l-ar ignora (vezi nota de
    // la neededHeight) şi ar redeschide prea scund.
    panel.style.maxHeight = neededHeight(panel) + 'px';
  }

  function close(li) {
    var panel = panelOf(li);
    if (!panel) return;
    cancelTransition(panel);
    // Forţează un punct de start real pentru tranziţie (vezi nota de mai
    // sus), dar prin reflow sincron, NU requestAnimationFrame — verificat
    // live că rAF nu se declanşează de fiecare dată în acest mediu (tab
    // throttling), lăsând tranziţia blocată la prima valoare scrisă şi
    // niciodată ajunsă la starea finală. `void panel.offsetHeight` forţează
    // browserul să calculeze layout-ul CU valoarea curentă înainte ca noua
    // valoare de mai jos să fie scrisă, deci tranziţia are un start->end
    // real fără să depindă de un callback de frame viitor.
    panel.style.maxHeight = neededHeight(panel) + 'px';
    void panel.offsetHeight;
    panel.style.maxHeight = '0px';
    li.classList.remove('am-acc-open');
    var toggle = li.querySelector(':scope > .am-acc-row > .am-acc-toggle');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
  }

  document.addEventListener('click', function (event) {
    if (!event.target.closest) return;

    var toggle = event.target.closest('.am-acc-toggle');

    /* ÎNTREG RÂNDUL DESCHIDE SUBMENIUL, nu doar +/− (Tudor, 2026-08-13:
       „daca se apas oriunde altundeva in afara de +/- symbol, nu deschide
       meniul dropdown ci ma duce pe o categorie random").

       Nu era o scăpare, ci efectul secundar al cererii din 12.08 („symbols
       must be small") plus alinierea la padding-ul de 16px: butonul a rămas
       32px dintr-un rând de 180px, adică 18% din lăţime şi sub minimul de
       44px pentru o ţintă de atingere. Restul de 147px erau `a.am-acc-link`,
       deci degetul nimerea aproape întotdeauna linkul — „Home Cinema" ducea
       la /collections/receivere-a-v în loc să deschidă submeniul.

       Regula nouă, aleasă de Tudor dintre trei variante: rândul deschide,
       exact ca la Peter Tyson (referinţa după care s-a construit accordionul).
       Categoria părinte rămâne accesibilă din primul link al submeniului
       („Toate pachetele PROMO", „Toate boxele pasive" etc.).

       ⚠️ DOAR pentru rândurile CU copii (`.am-acc-has-kids`). O categorie
       fără submeniu nu are ce deschide, iar interceptarea clickului acolo ar
       transforma un link funcţional într-un rând mort. Verificat în DOM:
       clasa e pusă de Liquid pe `li`, lângă `.am-acc-l1`/`.am-acc-l2`. */
    if (!toggle) {
      var row = event.target.closest('.am-acc-row');
      if (row && row.closest('#nav')) {
        var rowLi = row.closest('.am-acc-l1, .am-acc-l2');
        if (rowLi && rowLi.classList.contains('am-acc-has-kids')) {
          toggle = row.querySelector(':scope > .am-acc-toggle');
        }
      }
    }

    if (!toggle) return;
    if (!toggle.closest('#nav')) return;

    event.preventDefault();

    var li = toggle.closest('.am-acc-l1, .am-acc-l2');
    if (!li) return;

    var isOpen = li.classList.contains('am-acc-open');

    // Fraţii DIRECŢI ai lui `li`, în cadrul aceluiaşi părinte — nu toţi
    // .am-acc-open din #nav (vezi nota REGULA de mai sus).
    var siblingSelector = li.classList.contains('am-acc-l1') ? '.am-acc-l1' : '.am-acc-l2';
    Array.prototype.forEach.call(li.parentElement.children, function (sibling) {
      if (sibling !== li && sibling.matches && sibling.matches(siblingSelector) && sibling.classList.contains('am-acc-open')) {
        close(sibling);
        // Închide şi orice nivel-2 deschis în interiorul fratelui, ca starea
        // să nu rămână "expandat pe dinăuntru" când reintri în el mai târziu.
        sibling.querySelectorAll('.am-acc-l2.am-acc-open').forEach(close);
      }
    });

    if (isOpen) {
      close(li);
    } else {
      open(li);
    }

    // DUPĂ ce max-height-ul lui `li` a fost scris (şi după închiderea
    // fraţilor de mai sus, care şi ea schimbă înălţimea totală) — altfel
    // scrollHeight-ul părintelui s-ar citi încă pe layout-ul vechi.
    resyncAncestors(li);
  });

  // Recalculează max-height-ul panourilor deschise la resize — un accordion
  // deschis pe mobil landscape -> portrait (sau invers) altfel rămâne cu o
  // înălţime îngheţată din orientarea veche.
  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      document.querySelectorAll('#nav .am-acc-open > .am-acc-panel').forEach(function (panel) {
        panel.style.maxHeight = panel.scrollHeight + 'px';
      });
    }, 150);
  });
})();
